import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AlertController, ModalController } from '@ionic/angular';
import { ToastService } from 'src/app/core/toast.service';
import { ApiConsumidorService } from 'src/app/dao/api-consumidor.service';
import { UnidadeApiService } from 'src/app/dao/api_unidade.service';
import { GlobalService } from 'src/app/dao/global.service';
import { Consumidor } from 'src/app/model/consumidor';

@Component({
  selector: 'app-ficha-consumidor',
  templateUrl: './ficha-consumidor.page.html',
  styleUrls: ['./ficha-consumidor.page.scss'],
})
export class FichaConsumidorPage implements OnInit {

  constructor(private apiUnidade: UnidadeApiService, public modalController: ModalController, private router: Router, public alertController: AlertController, private global: GlobalService, private route: ActivatedRoute, private toast: ToastService, private apiconsumidor: ApiConsumidorService) { }

  idParam;
  title;
  consumidor: Consumidor;
  idConsumidor;

  ngOnInit() {
    this.consumidor = new Consumidor();
    const idParam = this.route.snapshot.paramMap.get('id');
    if (idParam) {
      console.log(idParam);
      this.idParam = idParam;
      this.title = 'Ficha de Consumidor';
      this.loadProd(idParam);
      this.idConsumidor = idParam;
    }

  }




   historico() {
    this.router.navigate(['/dados-historico/', this.idConsumidor]);
  }

  ranking() {
    this.router.navigate(['/selecao-analise/']);
  }

  async loadProd(id: string) {
    this.consumidor = await this.apiconsumidor.getById(id);
    console.log(this.consumidor);
  }

}
